import { useState } from 'react'
import { useExitIntent } from 'use-exit-intent'

import ExitModalComponent from '../../../components/ExitModal'

export const exitModalSessionStorageKey = 'quotesRequestExitModal'

const ExitModal: React.FC = () => {
  const [open, setOpen] = useState(false)

  const { registerHandler } = useExitIntent({
    desktop: {
      triggerOnIdle: false,
      useBeforeUnload: false,
      triggerOnMouseLeave: true,
    },
    mobile: {
      triggerOnIdle: true,
      delayInSecondsToTrigger: 10,
    },
  })

  const hasSeenExitModal = sessionStorage.getItem(exitModalSessionStorageKey) === '1'

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    sessionStorage.setItem(exitModalSessionStorageKey, '1')
  }

  if (!hasSeenExitModal) {
    registerHandler({
      id: 'quotesRequest',
      handler: () => { handleOpen() },
    })
  }

  return (
    <ExitModalComponent
      onClose={handleClose}
      open={open}
    />
  )
}

export default ExitModal
